import {AuthorizeAction, AuthorizeLoyaltyAction, AuthorizeVplusAction, GET_FCM_TOKEN, GET_MSISDN} from "store/constants"

export const doLogin = () => (dispatch) => {
  return dispatch({ 
    type: AuthorizeAction.LOGIN_ACTION
  })
}

export const doLogout = () => (dispatch) => {
  return dispatch({ 
    type: AuthorizeAction.LOGOUT_ACTION
  })
}

export const doLogin3G = () => (dispatch) => {
  return dispatch({ 
    type: AuthorizeAction.LOGIN_3G_4G
  })
}

export const doFCMToken = (data) => (dispatch) => {
  return dispatch({ 
    type: GET_FCM_TOKEN,
    payload: data
  })
}

export const doGetMsisdn = (data) => (dispatch) => {
  return dispatch({ 
    type: GET_MSISDN,
    payload: data
  })
}

export const doLoginVplus = () => (dispatch) => {
  return dispatch({ 
    type: AuthorizeVplusAction.LOGIN_VPLUS_ACTION
  })
}

export const doLogoutVplus = () => (dispatch) => {
  return dispatch({ 
    type: AuthorizeVplusAction.LOGOUT_VPLUS_ACTION
  })
}

export const doTokenHoiVienVplus = (data) => (dispatch) => {
  return dispatch({ 
    type: AuthorizeVplusAction.VPLUS_TOKEN_HOIVIEN,
    payload: data
  })
}

export const doTokenDevVplus = (data) => (dispatch) => {
  return dispatch({ 
    type: AuthorizeVplusAction.VPLUS_TOKEN_DEV,
    payload: data
  })
}

export const doTokenHoiVienEscVplus = (data) => (dispatch) => {
  return dispatch({ 
    type: AuthorizeVplusAction.VPLUS_TOKEN_HOIVIEN_ESC,
    payload: data
  })
}

export const doGetUserInfoVplus = (data) => (dispatch) => {
  return dispatch({ 
    type: AuthorizeVplusAction.VPLUS_USERINFO,
    payload: data
  })
}

export const doGetUserPromoMenu = (data) => (dispatch) => {
  return dispatch({ 
    type: AuthorizeVplusAction.VPLUS_USERPROMOMENU,
    payload: data
  })
}

export const doSetIsUpdateEmail = (data) => (dispatch) => {
  return dispatch({ 
    type: AuthorizeVplusAction.VPLUS_IS_UPDATE_EMAIL,
    payload: data
  })
}

export const doLoginLoyalty = () => (dispatch) => {
  return dispatch({
    type: AuthorizeLoyaltyAction.LOGIN_LOYALTY_ACTION
  });
};

export const doLogoutLoyalty = () => (dispatch) => {
  return dispatch({ 
    type: AuthorizeLoyaltyAction.LOGOUT_LOYALTY_ACTION
  })
}

export const doGetUserInfoLoyalty = (data) => (dispatch) => {
  return dispatch({ 
    type: AuthorizeLoyaltyAction.LOYALTY_USERINFO,
    payload: data
  })
}